import React, { useState, useEffect } from 'react';
import '../../../App.css';
import { useTranslation } from "react-i18next";
import {Link} from "react-router-dom";
import '../../../App.css';
import logo from '../../../assets/images/logo.png';

import './Navbar.css';
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";

function Navbar() {
    const { t } = useTranslation();
    const [click, setClick] = useState(false);
    const [servicesDropdown, setServicesDropdown] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);

    const handleServicesMouseEnter = () => {
        setServicesDropdown(true);
    };

    const handleServicesMouseLeave = () => {
        setServicesDropdown(false);
    };

    const toggleServicesDropdown = () => {
        if (isMobile) {
            setServicesDropdown(!servicesDropdown);
        }
    };


    const [button, setButton] = useState(true);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => {
        setClick(false);
        setServicesDropdown(false);
    }

    const showButton = () => {
        if (window.innerWidth <= 640) {
            setButton(false);
        } else {
            setButton(true);
        }
    };

    const combinedClickHandler = () => {
        handleClick();
        setServicesDropdown(false);
    };


    useEffect(() => {
        showButton();
    }, []);

    window.addEventListener('resize', showButton);

    return (
        <>
            <nav className="navbar">
                <div className="navbar-container">
                    <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
                        <img src={logo} alt="Logo" className="navbar-logo-image"/>
                    </Link>
                    <div className='menu-icon' onClick={combinedClickHandler}>
                        <i className={click ? 'fas fa-times' : 'fas fa-bars'}/>
                    </div>
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                        <li className="nav-item">
                            <Link to="/home" className="nav-links" onClick={closeMobileMenu}>
                                {t("Home")}
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to='/projects' className="nav-links" onClick={closeMobileMenu}>
                                {t("Projects")}
                            </Link>
                        </li>
                        <li
                            className="nav-item"
                            onMouseEnter={!isMobile ? handleServicesMouseEnter : null}
                            onMouseLeave={!isMobile ? handleServicesMouseLeave : null}
                            onClick={toggleServicesDropdown}
                        >
                            <Link to="/services" className="nav-links">
                                {t("Services")}
                            </Link>
                            {servicesDropdown && (
                                <ul className={servicesDropdown ? 'dropdown-menu active' : 'dropdown-menu'}>
                                    {isMobile &&
                                        <li className="dropdown-item">
                                            <Link className="dropdown-link" onClick={handleServicesMouseLeave}>&lt; {t("Back")}</Link>
                                        </li>
                                    }
                                    <li className="dropdown-item">
                                        <Link to="/services/complete-renovations"
                                              className="dropdown-link" onClick={closeMobileMenu}>{t("Complete Renovations")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/special-constructions"
                                              className="dropdown-link" onClick={closeMobileMenu}>{t("Special Constructions")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/bedrooms"
                                              className="dropdown-link" onClick={closeMobileMenu}>{t("Bedrooms")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/floor" className="dropdown-link" onClick={closeMobileMenu}>{t("Flooring")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/bathrooms" className="dropdown-link" onClick={closeMobileMenu}>{t("Bathrooms")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/kitchens" className="dropdown-link" onClick={closeMobileMenu}>{t("Kitchens")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/living-rooms"
                                              className="dropdown-link" onClick={closeMobileMenu}>{t("Living Rooms")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/lighting" className="dropdown-link" onClick={closeMobileMenu}>{t("Lighting")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/aluminum-frames"
                                              className="dropdown-link" onClick={closeMobileMenu}>{t("Aluminum Frames")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/smart-home"
                                              className="dropdown-link" onClick={closeMobileMenu}>{t("Smart Home")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/exterior-spaces"
                                              className="dropdown-link" onClick={closeMobileMenu}>{t("Exterior Spaces")}</Link>
                                    </li>
                                </ul>
                            )}
                        </li>
                        <li className="nav-item">
                            <Link to="/company" className="nav-links" onClick={closeMobileMenu}>
                                {t("Company")}
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/contact" className="nav-links" onClick={closeMobileMenu}>
                                {t("Contact")}
                            </Link>
                        </li>
                        <li className="language-selector" onClick={closeMobileMenu}>
                                <LanguageSwitcher/>
                        </li>
                    </ul>
                </div>
            </nav>
        </>

    )
}

export default Navbar
